import {routers} from '../../pages/index'
import router from '../../router/index'
import store from '../../store'
/**
 * 匹配是否可以跳转router
 * @param url
 */
const checkCanGoRouter = (url) => {
  console.log(' checkCanGoRouter', url)
  if (!url) return
  if (url.startsWith('go_')) {
    let res = url.replace('go_', '')
    let goRouter = res
    if (res.indexOf('/')) {
      let list = res.split('/')
      goRouter = list[0]
    }
    console.log(res)
    router.push(res)
    if (routers.hasOwnProperty(goRouter)) {
      return
    }
  }

  if (url.indexOf('http') > -1 || url.indexOf('https') > -1) {
    window.location.href = url
  }
}

const isWxgzh = () => {
  let ua = navigator.userAgent.toLowerCase()
  let isWeixin = ua.indexOf('micromessenger') !== -1
  if (isWeixin) {
    return true
  } else {
    return false
  }
}

const isEmpty = (object) => {
  if (Object.keys(object).length === 0) {
    return true
  }
  return false
}

const timeFilter = (time) => {
  return time < 60 ? time + '秒' : parseInt(time / 60) + '分' + (time % 60 < 10 ? '0' + time % 60 : time % 60) + '秒'
}

// 清空vuex缓存信息
const clearOrderInfo = () => {
  store.commit('Order/setCouponId', '')
  store.commit('Order/setOrderPrice', '')
  store.commit('Order/setCouponName', '选择优惠券')
  store.commit('Order/setCouponValue', 0)
  store.commit('Order/setShowPopup', false)
  store.commit('Order/setSelectTime', null)
  store.commit('Order/setSelectArea', null)
  store.commit('Order/setSelectField', null)
  store.commit('Order/setAddInfo', null)
  store.commit('Order/setProductId', null)
  store.commit('Order/setSelectRole', null)
  store.commit('Order/setPurpose', null)
}

const urlParams = () => {
  var url = decodeURI(location.search)
  var obj = {}
  if (url.indexOf('?') > -1) {
    var str = url.substr(1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      obj[strs[i].split('=')[0]] = strs[i].substr(strs[i].indexOf('=') + 1)
    }
  }
  return obj
}

// picker格式化value
const traverseSetItemText = (list) => {
  if (list && list instanceof Array) {
    list.map((item) => {
      item.text = item.dictName
    })
  }
  return list
}

function getChannel () {
  let path = location.pathname
  if (path) {
    if (path.indexOf('h5/') > -1) {
      path = path.split('h5/')[1]
      if (path.indexOf('/') > -1) {
        path = path.split('/')[0]
      }
    } else {
      if (path.indexOf('#') > -1) {
        path = path.split('#')[0]
        path = path.replace('/', '')
      } else {
        path = path.split('/')[1]
      }
    }
    if (path) {
      return path
    }
  }
  return 'gzh'
}

// 格式化时间
const getTimer = (date) => {
  let Y = date.getFullYear() + '-',
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-',
    D = date.getDate() + ' ',
    h = date.getHours()
  if (D.toString().length === 2) {
    D = '0' + D
  }
  if (h.toString().length === 1) {
    h = '0' + h
  }
  h = h + ':'
  let m = date.getMinutes()
  if (m.toString().length === 1) {
    m = '0' + m
  }
  console.log(Y + M + D + h + m)
  return Y + M + D + h + m
}

export default {checkCanGoRouter}

export {
  checkCanGoRouter,
  isWxgzh,
  timeFilter,
  isEmpty,
  urlParams,
  getChannel,
  getTimer,
  clearOrderInfo,
  traverseSetItemText

}



// WEBPACK FOOTER //
// ./src/libs/utils/utils.js